import api, { API_BASE, defaultOpt, noCache } from "./apiService";
import { createIndexList, createRowObj, filterTable } from "./tableUtils";

export async function getAllUsers() {
  // This requires a special case for rejects, as this list is attempted to be
  // pulled immediately on page display. Here we simply generate an empty
  // response
  return (
    await api.get(`${API_BASE}/list-users`, defaultOpt()).catch(() => {
      return { data: [] };
    })
  ).data;
}

export async function deleteUser(id) {
  return (
    await api.delete(`${API_BASE}/delete-user/${id}`, defaultOpt(noCache))
  ).data;
}

export async function updateUserDisplay(id, display_name) {
  return (
    await api.put(
      `${API_BASE}/update-user-display/${id}`,
      { display_name },
      defaultOpt(noCache),
    )
  ).data;
}

export async function updateUserRole(id, role) {
  return (
    await api.put(
      `${API_BASE}/update-user-role/${id}`,
      { role },
      defaultOpt(noCache),
    )
  ).data;
}

export async function updateUserPassword(id, password) {
  return (
    await api.put(
      `${API_BASE}/update-user-password/${id}`,
      { password },
      defaultOpt(noCache),
    )
  ).data;
}

export async function getUser(username) {
  return (await api.get(`${API_BASE}/get-user/${username}`, defaultOpt)).data;
}

export async function signupUser(username, password) {
  return (
    await api.post(`${API_BASE}/signup`, { username, password }, defaultOpt())
  ).data;
}

export async function loginUser(username, password) {
  return (
    await api.post(`${API_BASE}/login`, { username, password }, defaultOpt())
  ).data;
}

export function userOptions(userList) {
  const reducedUser = filterTable(userList, (user) => user.display_name);
  return createIndexList(reducedUser).map((idx) => {
    const user = createRowObj(reducedUser, idx);
    return {
      value: user.username,
      label: `(${user.username}) ${user.display_name}`,
    };
  });
}
